import React from 'react';
import Separator from './Separator';

const Profile = ({ name, profilePicture, location, linkedin }) => {
    return (
        <div style={styles.container}>
            {/* eslint-disable-next-line */}
            <img src={profilePicture} style={styles.profilePicture} />
            <h2>{name}</h2>
            <Separator />
            <div>
                <div style={styles.infoBlock}>
                    <i class="fa-brands fa-linkedin-in"></i>
                    <span><a href={linkedin.url}>{linkedin.short}</a></span>
                </div>
                <div style={styles.infoBlock}>
                    <i class="fa-solid fa-location-dot"></i>
                    <span>{location}</span>
                </div>
            </div>
        </div>
    );
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: '2rem',
        paddingBottom: '2rem',
        borderRadius: '2rem',
        gap: '1rem',
    },
    infoBlock: {
        display: 'flex',
        flexDirection: 'row',
        gap: '1rem',
        margin: '0.5rem'
    },
    profilePicture: {
        borderRadius: '15%',
        objectFit: 'cover',
        width: '220px',
        height: '220px',
    }
};

export default Profile;